import React from 'react';
import { _cs, isDefined } from '@togglecorp/fujs';

import Button from '#rsu/../v2/Action/Button';
import modalize from '#rscg/Modalize';

import ViewContext from '#components/ViewContext';
import NavDrawer from '#components/NavDrawer';

import styles from './styles.scss';

const ModalButton = modalize(Button);

interface Props {
    className?: string;
    canGoBack?: boolean;
    title?: string;
    buttons?: React.ReactNodeArray | React.ReactNode;
    children?: React.ReactNodeArray | React.ReactNode;
}

class AppBar extends React.PureComponent<Props> {
    public context!: React.ContextType<typeof ViewContext>;

    private goBack = ({ event }: { event: React.MouseEvent }) => {
        event.preventDefault();
        event.stopPropagation();
        window.history.back();
        // NOTE: Don't know if this is required
        return false;
    }

    private handleRefreshButtonClick = () => {
        window.location.reload();
    }

    public render() {
        const {
            className: classNameFromProps,
            children,

            title: titleFromProps,
            canGoBack,
        } = this.props;

        const className = _cs(
            classNameFromProps,
            styles.appbar,
        );

        const {
            appBarTitle,
            showBackButton,
            appBarChildren,
            userDetail,
        } = this.context;

        const shouldShowBackButton = isDefined(showBackButton)
            ? showBackButton
            : canGoBack;

        const title = isDefined(appBarTitle)
            ? appBarTitle
            : titleFromProps;

        return (
            <nav className={className}>
                <div className={styles.top}>
                    {shouldShowBackButton && (
                        <Button
                            className={styles.backButton}
                            transparent
                            iconName="back"
                            onClick={this.goBack}
                        />
                    )}
                    <h1 className={styles.title}>
                        {title}
                    </h1>
                    <Button
                        className={styles.refreshButton}
                        transparent
                        iconName="refresh"
                        onClick={this.handleRefreshButtonClick}
                    />
                    <ModalButton
                        className={styles.showNavDrawerButton}
                        transparent
                        iconName="menu"
                        modal={<NavDrawer userDetail={userDetail} />}
                    />
                </div>
                { (children || appBarChildren) && (
                    <div className={styles.bottom}>
                        { children }
                        { appBarChildren }
                    </div>
                )}
            </nav>
        );
    }
}

AppBar.contextType = ViewContext;

export default AppBar;
